<template>
  <div id="app">
    <div v-if="netWorks" style="height: 100%">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
    <div v-else style="height: 100%">暂无网络</div>
  </div>
</template>

<script>
// import {
// 	mapActions
// } from 'vuex'
export default {
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  name: "App",
  created() {},
  mounted() {
    let self = this;
    window.addEventListener("offline", function () {
      self.netWorks = false;
    });
    window.addEventListener("online", function () {
      self.netWorks = true;
    });
    // if (process.env.NODE_ENV !== "production") {
    // new window.VConsole();
    // }
  },
  data() {
    return {
      netWorks: true,
      netWorkimg: "",
      active: 0,
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
#app {
  position: relative;
  min-height: 100vh;
  // perspective: 100px;
  // transform: translateY(1px);
  background: #f6f6f6;
  border-left: solid 1px #ccc;
  border-right: solid 1px #ccc;
}
// 由于要兼容pc，设置固定宽度，如果是fixed定位需要水平居中，加fixed_horizo_center这个class名字，在全局样式reset.less里面
</style>
